import { TColors } from '@cian/ui-kit-design-tokens/colors';

import bonusSvg from './assets/bonus.svg';
import discountSvg from './assets/discount.svg';
import mortgageSvg from './assets/mortgage.svg';
import { EPromoLabelType } from '../../types/promos/promoLabel';

export const LABEL_BACKGROUNDS: Record<EPromoLabelType, TColors> = {
  [EPromoLabelType.Mortgage]: 'accent-main-secondary',
  [EPromoLabelType.NewbuildingCount]: 'background-primary',
  [EPromoLabelType.Discount]: 'surface-positive-default',
  [EPromoLabelType.Bonus]: 'surface-warning-default',
  [EPromoLabelType.Installment]: 'brand-mauve',
  [EPromoLabelType.NoOverpayments]: 'surface-positive-default',
};

export const LABEL_COLORS: Record<EPromoLabelType, TColors> = {
  [EPromoLabelType.Mortgage]: 'accent-main-primary',
  [EPromoLabelType.NewbuildingCount]: 'text-primary-default',
  [EPromoLabelType.Discount]: 'accent-positive-primary',
  [EPromoLabelType.Bonus]: 'theme-orange',
  [EPromoLabelType.Installment]: 'decorative-magentum',
  [EPromoLabelType.NoOverpayments]: 'accent-positive-primary',
};

export const LABEL_ICONS_MAP: Record<EPromoLabelType, string> = {
  [EPromoLabelType.Bonus]: bonusSvg,
  [EPromoLabelType.Discount]: discountSvg,
  [EPromoLabelType.Mortgage]: mortgageSvg,
  [EPromoLabelType.NewbuildingCount]: '',
  [EPromoLabelType.Installment]: '',
  [EPromoLabelType.NoOverpayments]: '',
};
